<template>
  <div v-loading="isLoading" class="special ly-card">
    <el-button class="comp-tr-top" type="primary" size="small" @click="handleAddTop">添加顶级节点</el-button>
    <el-button class="comp-tr-top m-l-15" type="primary" size="small" @click="exportExcel">导出</el-button>
    <div class="hd">
      <span>项目大类/项目</span>
      <span>代码</span>
    </div>
    <el-tree
      ref="SlotTree"
      :data="setTree"
      :node-key="NODE_KEY"
      :props="defaultProps"
      :expand-on-click-node="false"
      :default-expanded-keys="defaultExpandedKeys"
      highlight-current
      @node-drop="nodeDrop"
      :allow-drop="allowDrop"
      draggable
      @node-click="(data, node) => handleEdit(node, data)"
    >
      <div class="comp-tr width-full" slot-scope="{ node, data }" :class="!data.activate_status && 'disabled'">
        <div class="comp-tr-node">
          <!-- 编辑状态 -->
          <template v-if="node.isEdit || data.isEdit">
            <upload
              @successCBK="value => mediaChange('class_cover', value, data)"
              v-if="data.parent_id"
              accept=".jpg, .jpeg, .png, .gif, .bmp"
            >
              <template>
                <img
                  :src="data.class_cover ? `${baseUrl}/${data.class_cover}` : PLUS"
                  class="avt"
                  title="班级默认封面上传"
                />
                <i class="el-icon-circle-close" v-if="data.class_cover" @click.stop="() => delPic(data, 'class_cover')"></i>
              </template>
            </upload>
            <upload
              @successCBK="value => mediaChange('icon', value, data)"
              accept=".jpg, .jpeg, .png, .gif, .bmp"
            >
              <template>
                <img :src="data.icon ? `${baseUrl}/${data.icon}` : PLUS" class="avt" title="图标上传" />
                <i class="el-icon-circle-close" v-if="data.icon" @click.stop="() => delPic(data, 'icon')"></i>
              </template>
            </upload>
            <el-input
              v-model.trim="data.name"
              class="m-r-20"
              autofocus
              size="mini"
              :ref="`slotTreeInput'$data[NODE_KEY]Name}`"
              placeholder="项目名称"
              @keyup.enter.native="handleInput(node, data)"
            ></el-input>
            <el-input
              v-model.trim="data.code"
              class="m-r-20"
              autofocus
              size="mini"
              placeholder="项目代码"
              :ref="`slotTreeInput'${data[NODE_KEY]}Code`"
              @keyup.enter.native="handleInput(node, data)"
            ></el-input>
            <el-button size="mini" @click.stop="handleCancel(node, data)">取消</el-button>
            <el-button size="mini" type="primary" @click.stop="handleInput(node, data)">保存</el-button>
          </template>
          <!-- 非编辑状态 -->
          <template v-else>
            <!-- 名称： 新增节点增加class（is-new） -->
            <div class="left-content">
              <img
                v-if="data.parent_id"
                :src="data.class_cover ? `${baseUrl}/${data.class_cover}` : PLUS"
                title="班级默认封面"
                width="20"
                height="20"
              />
              <img :src="data.icon ? `${baseUrl}/${data.icon}` : PLUS" width="20" height="20" title="项目app图标" />
              <span :class="[data[NODE_KEY] < NODE_ID_START ? 'is-new' : '', 'comp-tr-node--name']">{{
                node.label
              }}</span>
            </div>
            <div class="inline-block">
              <span class="tree-code">{{ data.code }}</span>
              <!-- 按钮 -->
              <span class="comp-tr-node--btns">
                <!-- 禁用/启用 -->
                <el-tooltip
                  :content="data.is_sign_up_limit ? '报班数量限制禁用' : '报班数量限制启用'"
                  placement="top"
                  effect="light"
                  v-if="data.id && data.id > 0"
                >
                  <el-button
                    :icon="data.is_sign_up_limit ? 'el-icon-turn-off' : 'el-icon-open'"
                    size="mini"
                    circle
                    :type="data.is_sign_up_limit ? 'danger' : 'primary'"
                    @click.stop="handleLimitStatus(node, data)"
                  ></el-button>
                </el-tooltip>
                <span class="m-r-10"></span>
                <!-- 新增 -->
                <el-tooltip content="添加子专业" placement="top" effect="light">
                  <el-button
                    icon="el-icon-plus"
                    size="mini"
                    circle
                    type="primary"
                    @click.stop="handleAdd(node, data)"
                  ></el-button>
                </el-tooltip>
                <!-- 编辑 -->
                <el-tooltip content="编辑" placement="top" effect="light">
                  <el-button
                    icon="el-icon-edit"
                    size="mini"
                    circle
                    type="info"
                    @click.stop="handleEdit(node, data)"
                  ></el-button>
                </el-tooltip>
                <span class="m-r-10"></span>
                <!-- 禁用/启用 -->
                <el-tooltip :content="data.activate_status ? '禁用' : '启用'" placement="top" effect="light">
                  <el-button
                    :icon="data.activate_status ? 'el-icon-turn-off' : 'el-icon-open'"
                    size="mini"
                    circle
                    :type="data.activate_status ? 'danger' : 'primary'"
                    @click.stop="handleStatus(node, data)"
                  ></el-button>
                </el-tooltip>
                <!-- 删除 -->
                <el-tooltip content="删除" placement="top" effect="light">
                  <el-button
                    icon="el-icon-delete"
                    size="mini"
                    circle
                    type="danger"
                    @click.stop="handleDelete(node, data)"
                  ></el-button>
                </el-tooltip>
              </span>
            </div>
          </template>
        </div>
      </div>
    </el-tree>
  </div>
</template>

<script>
import { Input, Tree, Tooltip } from 'element-ui';
import { base } from '@/api';
import Upload from '@/components/Upload';
import utils from '@/utils/utils';

const PLUS = require('@/assets/images/upload.png');

export default {
  name: 'special',
  components: {
    ElTree: Tree,
    ElInput: Input,
    Upload,
    ElTooltip: Tooltip
  },
  data() {
    return {
      isLoading: false, // 是否加载
      setTree: [], // tree数据
      NODE_KEY: 'id', // id对应字段
      NODE_ID_START: 0, // 新增节点id，逐次递减
      startId: null,
      tempData: null, // 缓存正在编辑的节点
      defaultProps: {
        // 默认设置
        children: 'children',
        label: 'name',
        disabled: data => !data.activate_status
      },
      initParam: {
        // 新增参数
        name: '',
        activate_status: true,
        parent_id: null,
        icon: '',
        class_cover: '',
        is_sign_up_limit: false,
        children: []
      },
      isAdd: false, // 是否存在新增节点
      PLUS,
      baseUrl: '',
      defaultExpandedKeys: [],
      allowDrop(draggingNode, dropNode, type) {
        if (type === 'inner') return false;
        if (draggingNode.data.parent_id !== dropNode.data.parent_id) return false;
        return true;
      }
    };
  },
  created() {
    // 初始值
    this.startId = this.NODE_ID_START;
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.isLoading = true;
      const { data } = await base.special({ methold: 'get' });
      this.isLoading = false;
      this.setTree = data.tree;

      this.baseUrl = await this.$store.dispatch('app/getOssUrl');
      setTimeout(() => {
        document.querySelector('.special .hd').style.width = `${
          document.querySelector('.special .comp-tr-node>.inline-block').offsetLeft
        }px`;
      }, 0);
    },
    handleDelete(_node, _data) {
      // 判断是否存在子节点
      if (_data.children && _data.children.length !== 0) {
        this.$message.error('此节点有子级，不可删除！');
      } else {
        // 删除操作
        const DeletOprate = () => {
          if (this.$refs.SlotTree) {
            // 新增节点不用调api
            if (_data[this.NODE_KEY] < 0) {
              this.$refs.SlotTree.remove(_data);
              this.isAdd = false;
              return;
            }
            base.controlSpecial({ id: _data[this.NODE_KEY], methold: 'delete' }).then(res => {
              if (res) {
                this.$refs.SlotTree.remove(_data);
                this.$message.success(res.msg || '删除成功！');
                this.defaultExpandedKeys = _data.parent_id ? [_data.parent_id] : [];
              }
            });
          }
        };
        // 二次确认
        const ConfirmFun = () => {
          this.$confirm('是否删除此项目？', '提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              DeletOprate();
            })
            .catch(() => {});
        };
        // 判断是否新增： 新增节点直接删除，已存在的节点要二次确认
        if (_data[this.NODE_KEY] < this.NODE_ID_START) DeletOprate();
        else ConfirmFun();
      }
    },
    handleCancel(_node, _data) {
      // 退出编辑状态
      if (_node.isEdit || _data.isEdit) {
        // eslint-disable-next-line no-param-reassign
        _node.isEdit = false;
        // eslint-disable-next-line no-param-reassign
        _data.isEdit = false;
        // eslint-disable-next-line no-param-reassign
        _data.name = this.tempData.name;
      }
      this.tempData = null;

      if (_data[this.NODE_KEY] < this.NODE_ID_START) {
        this.handleDelete(_node, _data);
      }
      this.isAdd = false;
    },
    mediaChange(key, value, data) {
      // eslint-disable-next-line no-param-reassign
      if (value && value.length) data[key] = value[0].url;
    },
    async handleInput(_node, _data) {
      // 提交编辑
      if (_node.isEdit || _data.isEdit) {
        let res = null;
        const tmp = { ..._data };
        if (!tmp.parent_id) {
          delete tmp.parent_id;
          // 顶级项目重复判断
          const isRepeat = this.setTree.some(item => item.name === tmp.name && item.id !== tmp.id);
          if (isRepeat) {
            this.$message.error('项目名称重复！');
            return;
          }
        }
        if (_data[this.NODE_KEY] < this.NODE_ID_START) {
          // 新增项目
          res = await base.special({
            params: tmp,
            methold: 'post'
          });
        } else {
          res = await base.controlSpecial({
            id: _data[this.NODE_KEY],
            params: tmp,
            methold: 'put'
          });
        }
        if (res && res.data.specialized_subject) {
          this.$message.success(res.msg || '操作成功');
          this.isAdd = false;
          this.tempData = null;
          this.init();
          this.defaultExpandedKeys = res.data.specialized_subject.parent_id
            ? [res.data.specialized_subject.parent_id]
            : [];
        }
      }
    },
    handleEdit(_node, _data) {
      if (this.tempData) {
        if (_data.id !== this.tempData.id && _data.id !== -1) this.$message.warning('请先编辑新增的项目');
        return;
      }
      // 设置编辑状态
      if (!_node.isEdit) {
        this.$set(_node, 'isEdit', true);
        this.tempData = JSON.parse(JSON.stringify(_data));
      }
      // 输入框聚焦
      this.$nextTick(() => {
        if (this.$refs[`slotTreeInput${_data[this.NODE_KEY]}Name`]) {
          this.$refs[`slotTreeInput${_data[this.NODE_KEY]}Name`].$refs.input.focus();
        }
      });
    },
    async handleStatus(_node, _data) {
      let res = null;
      if (_data.activate_status) {
        // 禁用
        res = await base.deactivateSpecial({ id: _data.id });
        /* eslint-disable-next-line no-param-reassign */
        _data.activate_status = false;
      } else {
        // 启用
        res = await base.activateSpecial({ id: _data.id });
        /* eslint-disable-next-line no-param-reassign */
        _data.activate_status = true;
      }
      if (res) {
        this.$message.success(res.msg || '操作成功');
        if (_data.children) this.init();
      }
    },
    async handleLimitStatus(_node, _data) {
      const temp = { ..._data };
      if (!temp.parent_id || temp.parent_id < 0) delete temp.parent_id;
      const res = await base.controlSpecial({
        id: _data[this.NODE_KEY],
        params: {
          ...temp,
          is_sign_up_limit: !temp.is_sign_up_limit
        },
        methold: 'put'
      });
      if (res) {
        this.$message.success(res.msg || '操作成功');
        this.init();
      }
    },
    handleAdd(_node, _data) {
      if (this.isAdd) {
        this.$message.warning('请先完成上次编辑');
        return false;
      }
      // 参数修改
      const obj = JSON.parse(JSON.stringify(this.initParam)); // copy参数
      obj.parent_id = _data[this.NODE_KEY]; // 父id
      this.startId -= 1;
      obj[this.NODE_KEY] = this.startId; // 节点id：逐次递减id
      obj.isEdit = true;
      this.tempData = obj;
      // 判断字段是否存在
      if (!_data.children) {
        this.$set(_data, 'children', []);
      }
      // 新增数据
      // _data.children.push(obj);
      // eslint-disable-next-line no-param-reassign
      _data.children = [..._data.children, obj];
      // 展开节点
      if (!_node.expanded) {
        // eslint-disable-next-line no-param-reassign
        _node.expanded = true;
      }
      this.isAdd = true;
      return true;
    },
    handleAddTop() {
      if (this.isAdd) {
        this.$message.warning('请先完成上次编辑');
        return;
      }
      this.isAdd = true;
      // 添加顶部节点
      const obj = JSON.parse(JSON.stringify(this.initParam)); // copy参数
      obj.isEdit = true;
      this.tempData = { ...obj };
      this.startId -= 1;
      obj[this.NODE_KEY] = this.startId; // 节点id：逐次递减id
      this.setTree.push(obj);
    },
    nodeDrop(curNode, endNode, position) {
      let id = -1;
      if (position === 'before') {
        id = endNode.previousSibling.previousSibling ? endNode.previousSibling.previousSibling.data.id : -1;
      }
      if (position === 'after') {
        ({ id } = endNode.data);
      }
      base
        .specializedOrder({
          params: {
            specialized_subject_id: curNode.data.id,
            previous_specialized_subject_id: id
          }
        })
        .then(res => {
          if (res) {
            this.$message.success(res.msg || '更新成功！');
          }
        });
    },
    delPic(data, key) {
      base
        .controlSpecial({
          id: data.id,
          params: { ...data, [key]: '' },
          methold: 'put'
        })
        .then(res => {
          if (res) {
            this.$message.success(res.msg || '删除成功！');
            // eslint-disable-next-line no-param-reassign
            data[key] = null;
          }
        });
    },
    exportExcel() {
      base
        .exportSpecializedSubject()
        .then(data => {
          if (data) utils.downloadData(data, '项目列表');
        });
    }
  }
};
</script>

<style lang="less">
.special {
  > .hd {
    display: flex;
    justify-content: space-between;
    margin-left: 23px;
    margin-bottom: 10px;
    font-weight: 700;
  }
  .el-tree {
    display: inline-block;
    font-size: 14px;
    min-width: 600px;
  }
  .el-tree-node {
    padding: 3px 0;
  }
  overflow: auto;
  // 顶部按钮
  .comp-tr-top {
    width: 100px;
    margin-bottom: 2em;
  }
  .comp-tr.disabled {
    color: #ccc;
  }
  // 自定义节点
  .comp-tr-node {
    // label
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tree-code {
      display: inline-block;
      min-width: 150px;
      margin-right: 20px;
    }
    .comp-tr-node--name {
      display: inline-block;
      line-height: 40px;
      min-height: 40px;
      // 新增
      &.is-new {
        font-weight: bold;
      }
    }
    // button
    .comp-tr-node--btns {
      margin-left: 10px;
      opacity: 0;
      transition: opacity 0.1s;
      .el-button {
        transform: scale(0.8); // 缩小按钮
        & + .el-button {
          margin-left: -1px;
        }
      }
    }
    .avt {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      margin-right: 10px;
    }
    .left-content {
      img {
        vertical-align: sub;
        margin-right: 10px;
      }
    }
  }
  // 高亮显示按钮
  .is-current {
    & > .el-tree-node__content {
      .comp-tr-node--btns {
        opacity: 1;
      }
    }
  }
  // 悬浮显示按钮
  .el-tree-node__content {
    &:hover {
      .comp-tr-node--btns {
        opacity: 1;
      }
    }
  }
  .upload-container {
    position: relative;
  }
  .el-icon-circle-close {
    color: @danger;
    position: absolute;
    top: -5px;
    right: -1px;
  }
}
</style>
